module.exports = __webpack_public_path__ + "static/media/XeroIcon.e41671f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/account/integrations/XeroIcon.png
// module id = 2241
// module chunks = 0